<template>
	<div class="hd-moa-frame-protein-created">
		<base-image-svg
			class="js-moa-frame-protein-created hd-moa-frame-protein-created__svg"
			:source="require('!html-loader!../../assets/svgs/06-moa-frame-protein-created.svg')"
		/>
		<base-image-svg
			class="js-moa-frame-protein-created hd-moa-frame-protein-created__svg hd-moa-frame-protein-created__svg--mobile"
			:source="require('!html-loader!../../assets/svgs/06-moa-frame-protein-created-mobile.svg')"
		/>
	</div>
</template>

<style lang="scss" scoped>
	.hd-moa-frame-protein-created {
		position: absolute;
		@include box(100%);
		width: calc(100% - 220px);
		left: 220px;
		bottom: 0;

		&__svg {
			&--mobile.hd-base-image-svg {
				display: none;
			}
		}

		:deep() svg {
			position: absolute;
			left: 0;
			@include center-y();
			width: 100%;

			#protein-secondary {
				@include animation-float();
			}

			#Proteins {
				@include fade-out();
				transform: translate(-5%, 5%);
			}

			#rna-element,
			#protein-primary {
				@include animation-float-mini();
			}
			#ribosome-group {
				@include animation-float-reverse-mini();
			}

			#Ribosome,
			#Ribosome_Shade_and_Highlights,
			#Ribosome_Outline {
				@include fade-out();
				transform: translate(10%, -5%);
			}

			#rna {
				@include fade-out();
				transform: translate(20%, 5%);
			}

			#Labels {
				@include fade-out();
			}

			.protein-element {
				@include fade-out();
				transition: all 1s ease;
			}
		}

		// Animations
		[data-state="animation-ready"] {
			:deep() svg {
				#Ribosome, #Ribosome_Shade_and_Highlights,
				#Ribosome_Outline {
					@include transition-frame-fade-in();
				}

				#rna {
					@include transition-frame-fade-in();
					transition-delay: 0.15s;
				}

				#Proteins {
					@include transition-frame-fade-in();
					transition-delay: 0.5s;
				}

				.protein-element {
					opacity: 1;
					transition: all 1.5s ease;
					
					&.protein-element-1 { transition-delay: 0.25s;}
					&.protein-element-2 { transition-delay: 0.5s; }
					&.protein-element-3 { transition-delay: 0.75s; }
					&.protein-element-4 { transition-delay: 1s; }
					&.protein-element-5 { transition-delay: 1.25s; }
					&.protein-element-6 { transition-delay: 1.5s; }
					&.protein-element-7 { transition-delay: 1.75s; }
					&.protein-element-8 { transition-delay: 2s; }
					&.protein-element-9 { transition-delay: 2.25s; }
					&.protein-element-10 { transition-delay: 2.5s; }
				}

				#Labels {
					opacity: 1;
					transition-delay: 2s;
				}
			}
		}

		// Responsive 
		@include res-screen-small {
			@include box(90%);
			:deep() svg {
				max-width: 900px;
			}
		}

		@include res-screen-x-small {
			:deep() svg {
				max-width: 650px;
			}
		}

		@include res-screen-portrait {
			@include center();
			@include box(100%);
		}
		
		@include res-screen-portrait-sm {
			&__svg {
				display: none;

				&--mobile.hd-base-image-svg {
					display: flex;
				}
			}
		}
	}
</style>

